import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { removeFromLibraryLabels } from 'app/common/common.labels';

export interface RemoveFromLibraryDialogData {
  appName: string;
}

export type RemoveFromLibraryDialogResult = 'remove' | 'cancel';

@Component({
  selector: 'app-remove-from-library-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './remove-from-library-dialog.component.html',
  styleUrl: './remove-from-library-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoveFromLibraryDialogComponent {
  className = 'remove-from-library-dialog';
  labels = removeFromLibraryLabels;

  constructor(
    private dialogRef: MatDialogRef<
      RemoveFromLibraryDialogComponent,
      RemoveFromLibraryDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: RemoveFromLibraryDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close('cancel');
  }

  onRemove(): void {
    this.dialogRef.close('remove');
  }
}
